export class Label {
    constructor(
        private ctx: CanvasRenderingContext2D,
        private text: string,
        private x: number,
        private y: number,
        private color: string,
        private fontSize: number,
        private align: CanvasTextAlign = 'left',
        private baseline: CanvasTextBaseline = 'middle',
        private maxWidth?: number
    ) {
    }

    draw(): void {
        this.ctx.fillStyle = this.color;
        this.ctx.font = `${this.fontSize}px Inter, sans-serif`;
        this.ctx.textAlign = this.align;
        this.ctx.textBaseline = this.baseline;  
        this.ctx.fillText(this.text, this.x, this.y, this.maxWidth);
    }

    static createCentered(
        ctx: CanvasRenderingContext2D,
        text: string,
        x: number,
        y: number,
        color: string,
        fontSize: number
    ): Label {
        return new Label(ctx, text, x, y, color, fontSize, 'center', 'middle');
    }

    static createLeftAligned(
        ctx: CanvasRenderingContext2D,
        text: string,
        x: number,
        y: number,
        color: string,
        fontSize: number
    ): Label {
        return new Label(ctx, text, x, y, color, fontSize, 'left', 'middle');
    }

    static createForPoint(
        ctx: CanvasRenderingContext2D,
        text: string,
        pointX: number,
        pointY: number,
        centerX: number,
        fontSize: number,
        offset: number = 30,
        color: string = '#FFF'
    ): Label {
        let labelX: number;
        let align: CanvasTextAlign;
        if (pointX < centerX) {
            labelX = pointX - offset;
            align = 'right';
        } else {
            labelX = pointX + offset;
            align = 'left';
        }
        return new Label(ctx, text, labelX, pointY, color, fontSize, align, 'middle');
    }
} 